import type { EditableZoomHostFilter } from '../types';

export function createEmptyZoomHostFilter (): EditableZoomHostFilter[] {
  return [{
    zoom_host_filter_expressions: [],
  }];
}
